import { toast as reactHotToast } from 'react-hot-toast'

type Success = typeof reactHotToast.success
type Error = typeof reactHotToast.error

interface Notify {
  success: Success
  error: Error
  dismiss: (id: string) => void
}

const toast: Notify = {
  success: (message, options) =>
    reactHotToast.success(message, {
      ...options,
      ariaProps: {
        role: 'status',
        'aria-live': 'polite'
      },
      className: `testid-toast-success`
    }),
  error: (message, options) =>
    reactHotToast.error(message, {
      ...options,
      ariaProps: {
        role: 'alert',
        'aria-live': 'assertive'
      },
      className: `testid-toast-error`
    }),
  dismiss: id => reactHotToast.dismiss(id)
}

export default toast
